import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from "./FileAppResource";
import ContactAppResource from "./ContactAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";
import UserAppResource from "./UserAppResource";
import OrganizationMemberAppResource from "./OrganizationMemberAppResource";
import LuWorkspaceMembershipTypeAppResource from "./LuWorkspaceMembershipTypeAppResource";
import WorkspaceRoleAppResource from "./WorkspaceRoleAppResource";
import StageWorkspaceMemberAppResource from "./StageWorkspaceMemberAppResource";
import StageRoleAppResource from "./StageRoleAppResource";
import ChannelAppResource from "./ChannelAppResource";
import TaskAppResource from "./TaskAppResource";
import TaskCategoryAppResource from "./TaskCategoryAppResource";
import TaskPriorityAppResource from "./TaskPriorityAppResource";
import TaskStatusAppResource from "./TaskStatusAppResource";
import TaskAssigneeAppResource from "./TaskAssigneeAppResource";
import TaskRoleAppResource from "./TaskRoleAppResource";
import CalendarAppResource from "./CalendarAppResource";
import CalendarEventAppResource from "./CalendarEventAppResource";
import CalendarEventAttendeeAppResource from "./CalendarEventAttendeeAppResource";
import JotFormSessionAppResource from "./JotFormSessionAppResource";
import WorkspaceMemberNotificationAppResource from "./WorkspaceMemberNotificationAppResource";

class WorkspaceOrganizationMemberAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Workspace-Organization-Member';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'workspaces/members';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
            'created_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'hasLoggedIn',
            'lastLogin',
            'workspaceUuid',
            'organizationMemberUuid',
            'avatarFileUuid',
            'contactUuid',
            'userUuid',
            'workspaceRoleUuid',
            'workspaceMembershipTypeUuid',
            'user',
            'workspace',
            'avatarFile',
            'contact',
            'organizationMember',
            'messages',
            'stageWorkspaceMembers',
            'messageMentions',
            'stageRoles',
            'channels',
            'tasks',
            'taskCategories',
            'taskPriorities',
            'taskStatuses',
            'taskAssignees',
            'taskRoles',
            'calendars',
            'calendarEvents',
            'calendarMembers',
            'calendarEventAttendees',
            'workspaceMembershipType',
            'onboarding',
            'notifications',
            'meta'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            avatarFile: FileAppResource,
            contact: ContactAppResource,
            workspace: WorkspaceAppResource,
            user: UserAppResource,
            organizationMember: OrganizationMemberAppResource,
            workspaceMembershipType: LuWorkspaceMembershipTypeAppResource,
            workspaceRole: WorkspaceRoleAppResource,
            stageWorkspaceMembers: StageWorkspaceMemberAppResource,
            stageRoles: StageRoleAppResource,
            channels: ChannelAppResource,
            tasks: TaskAppResource,
            taskCategories: TaskCategoryAppResource,
            taskPriorities: TaskPriorityAppResource,
            taskStatuses: TaskStatusAppResource,
            taskAssignees: TaskAssigneeAppResource,
            taskRoles: TaskRoleAppResource,
            calendars: CalendarAppResource,
            calendarEvents: CalendarEventAppResource,
            calendarEventAttendees: CalendarEventAttendeeAppResource,
            jotFormSession: JotFormSessionAppResource,
            notifications: WorkspaceMemberNotificationAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            avatarFile: 'avatar_file_uuid',
            contact: 'contact_uuid',
            workspace: 'workspace_uuid',
            user: 'user_uuid',
            organizationMember: 'organization_member_uuid',
            workspaceMembershipType: 'workspace_membership_type_uuid',
            workspaceRole: 'workspace_role_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            workspaceUuid: {
                type: 'string',
                presence: true,
            },
            organizationMemberUuid: {
                type: 'string',
                presence: true,
            },
            contactUuid: {
                type: 'string',
            },
            workspaceRoleUuid: {
                type: 'string',
                presence: true,
            },
            workspaceMembershipTypeUuid: {
                type: 'string',
            },
            avatarFileUuid: {
                type: 'string',
            },
            hasLoggedIn: {
                type: 'boolean',
            },
            lastLogin: {
                datetime: true,
            },
            onboarding: {},
            meta: {},
            userUuid: {
                type: 'string',
            },
        };
    }

}

export default WorkspaceOrganizationMemberAppResource;
